<template>
    <SearchSelectionPane></SearchSelectionPane>
    <SearchContentPane :searchType="searchType" :setMfrId="currentSearchMfrId" :setText="currentSearchText" :manufacturerItems="manufacturerItems" @searchRequest="search"></SearchContentPane>
    <InfluencedPartAd v-bind:partAd="influencedPartAdItem"></InfluencedPartAd>
    <InfluencedRefDesAd v-bind:refDesAd="influencedRefDesAdItem"></InfluencedRefDesAd>
    <SearchResultPane :searchItems="searchItems"></SearchResultPane>
    <Pager v-if="showPaging" :page="currentPage" :maxPage="currentMaxPage" @paged="pageSearch"></Pager>
</template>

<script>
    import { mapState } from 'vuex'
    import SearchContentPane from './search-content-pane.vue'
    import SearchResultPane from './search-results-pane.vue'
    import SearchSelectionPane from './search-selection-pane.vue'
    import Pager from './pager.vue'
    import partApiClient from '@/services/apiServices/partApiClient.js'
    import InfluencedPartAd from '@/components/ad/influenced-part-ad.vue'
    import InfluencedRefDesAd from '@/components/ad/influenced-ref-des-ad.vue'

    export default {
        name: 'SearchPanel',
        components: {
            SearchSelectionPane,
            SearchContentPane,
            SearchResultPane,
            Pager,
            InfluencedPartAd,
            InfluencedRefDesAd
        },
        data() {
            return {
                lastSearchType:"",
                lastPart: "",
                lastSearchMfrId: "",
                lastSearchText: "",
                currentSearchMfrId: "",
                currentSearchText: "",
                searchItems: [],
                influencedPartAdItem: null,
                influencedRefDesAdItem: null,
                currentPage: 1,
                currentMaxPage: 0,
                showPaging: false
            }
        },
        computed: {
            ...mapState({
                searchMfrId: state => state.search.mfrId,
                searchText: state => state.search.text,
                searchPage: state => state.search.page,
                instance: state => state.instance
            }),
            influenceSearchItem: function () {
                if (this.influencedPartAdItem && this.influencedPartAdItem != null) {
                    return this.influencedPartAdItem;
                } else if(this.influencedRefDesAdItem && this.influencedRefDesAdItem != null) {
                    return this.influencedRefDesAdItem
                }
                return null;
            }
        },
        props: {
            searchType: {
                type: String,
                default: () => {
                    return "internal"
                }
            },
            manufacturerItems: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        methods: {
            search: async function (manufacturerId, searchTerm, searchType, page) {

                await this.$router.isReady();
                this.$store.commit('SEARCH_START');

                var redirectUrl = null;

                var key = null;
                var mfrkey = '';
                var srckey = '';
                var pkey = '';
                if (searchType == "external") {
                    key = 'keyword';
                } else {
                    key = 'pn';
                }

                if (manufacturerId && manufacturerId != null && manufacturerId != "") {
                    mfrkey = `/mfr/${manufacturerId}`;
                }

                if (searchTerm && searchTerm != null && searchTerm != "") {
                    searchTerm = encodeURIComponent(searchTerm.replace('*', '').replace('%', ''));
                    srckey = `/src/${searchTerm}`;
                }

                if (page == null || page == "" || page == 0) {
                    page = 0;
                }

                if (page) {
                    pkey = `/p/${page}`;
                }

                redirectUrl = `/${this.instance}/search/${key}${mfrkey}${srckey}${pkey}`;
                if (this.$route.path != redirectUrl) {
                    this.loading = true;
                    this.$router.push(redirectUrl);
                }


                if (
                    this.lastSearchType != searchType ||
                    this.lastSearchMfrId != manufacturerId ||
                    this.lastSearchText != searchTerm ||
                    this.lastPage != page
                ) {
                    this.lastSearchType = searchType;
                    this.lastSearchMfrId = manufacturerId;
                    this.lastSearchText = searchTerm;
                    this.lastPage = page;

                    return partApiClient.GetSearchPage(manufacturerId, searchTerm, searchType, page).then(response => {

                        this.searchItems = response.data.items;
                        this.currentMaxPage = response.data.paging.maxPage;
                        this.showPaging = response.data.paging.showPaging;

                        this.influencedPartAdItem = response.data.influencedPartAdItem;

                        this.influencedRefDesAdItem = response.data.influencedRefDesAdItem;
                        if (this.influencedRefDesAdItem != null && this.$parent.currentPanel == 'search') {
                            this.$store.dispatch('gtmReferenceInfluence', { mfrName: this.influencedRefDesAdItem.manufacturerName, mfrPN: this.influencedRefDesAdItem.manufacturerPartNumber });
                        }

                        this.loading = false;
                        this.$store.commit('SEARCH_COMPLETE');

                        this.$store.dispatch('gtmSearch', { search: searchTerm, mfr: manufacturerId, queryType: searchType, numResults: response.data.resultCount, influencedSearchResult: this.influenceSearchItem });

                    }).catch(() => {
                        this.$store.commit('SET_GLOBAL_ERROR', 'Search Api Temporarily Unavailable');
                        this.$store.commit('CLEAR_SEARCH_LOAD');
                    });
                } else {
                    this.loading = false;
                    this.$store.commit('SEARCH_COMPLETE')
                }
            },
            pageSearch: async function (pageNumber) {
                await this.$router.isReady();
                if (!this.loading)
                    await this.search(this.searchMfrId, this.searchText, this.searchType, pageNumber);
            }
        },
        mounted() {
            //subscribes to search mutations
            this.unsubsearchpanel = this.$store.subscribe((mutation) => {
                switch (mutation.type) {
                    case "SET_SEARCH_VALUES":
                        //Set values for decendent elements
                        this.currentSearchMfrId = mutation.payload.searchManufacturerId;
                        this.currentSearchText = mutation.payload.searchText;
                        if (!this.loading) 
                            this.search(mutation.payload.searchManufacturerId, mutation.payload.searchText, mutation.payload.searchType, mutation.payload.page);
                        break;
                    }
                }
            )
        },
        beforeUnmount() {
            this.unsubsearchpanel();
        },
    };
</script>

<style scoped>
</style>